exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3f7-WqBuz_Vc2CRQS0kSTk{min-width:44px;display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._1P-DRKZKWYB2wBUEG1S7YV{-webkit-transform:unset!important;transform:unset!important}", ""]);
// Exports
exports.locals = {
	"bigHoverActionContainer": "_3f7-WqBuz_Vc2CRQS0kSTk",
	"animatedBigHoverAction": "_1P-DRKZKWYB2wBUEG1S7YV"
};